// src/Profile.js
import React from 'react';
import './Profile.css';

function Profile() {
  return (
    <div className="profile-container">
      <h2>Your Profile</h2>
      <div className="profile-info">
        <p>Username: JohnDoe</p>
        <p>Email: johndoe@example.com</p>
        {/* Add more profile details here */}
      </div>
    </div>
  );
}

export default Profile;
